module.exports = __webpack_public_path__ + "static/media/garden.62ae13fd.jpg";